module.exports = "<img\r\n    [src]=\"imageId | imageUrl:type\"\r\n    style=\"max-width: 100%;max-height: 160px;\"\r\n    #image\r\n    (error)=\"onError()\"\r\n    (load)=\"onLoaded(el.nativeElement, image); loaded = true\"\r\n    (click)=\"showBigImage($event, imageId, imageMatrix)\"\r\n    [ngStyle]=\"this.loadStyle\"\r\n/>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/commons/simple-image/simple-image.component.html
// module id = ./src/app/commons/simple-image/simple-image.component.html
// module chunks = main